export const BRAZILIAN_STATES = [
  { uf: "AC", name: "Acre" },
  { uf: "AL", name: "Alagoas" },
  { uf: "AP", name: "Amapá" },
  { uf: "AM", name: "Amazonas" },
  { uf: "BA", name: "Bahia" },
  { uf: "CE", name: "Ceará" },
  { uf: "DF", name: "Distrito Federal" },
  { uf: "ES", name: "Espírito Santo" },
  { uf: "GO", name: "Goiás" },
  { uf: "MA", name: "Maranhão" },
  { uf: "MT", name: "Mato Grosso" },
  { uf: "MS", name: "Mato Grosso do Sul" },
  { uf: "MG", name: "Minas Gerais" },
  { uf: "PA", name: "Pará" },
  { uf: "PB", name: "Paraíba" },
  { uf: "PR", name: "Paraná" },
  { uf: "PE", name: "Pernambuco" },
  { uf: "PI", name: "Piauí" },
  { uf: "RJ", name: "Rio de Janeiro" },
  { uf: "RN", name: "Rio Grande do Norte" },
  { uf: "RS", name: "Rio Grande do Sul" },
  { uf: "RO", name: "Rondônia" },
  { uf: "RR", name: "Roraima" },
  { uf: "SC", name: "Santa Catarina" },
  { uf: "SP", name: "São Paulo" },
  { uf: "SE", name: "Sergipe" },
  { uf: "TO", name: "Tocantins" },
];

const citiesCache = new Map();

export const buildCityLabel = (cityName, uf) => {
  if (!cityName) return "";
  return uf ? `${cityName} - ${uf}` : cityName;
};

export const parseCityAndUf = (value) => {
  const rawValue = String(value || "").trim();
  const match = rawValue.match(/^(.*?)(?:\s*-\s*([A-Z]{2}))?$/);
  return {
    city: (match?.[1] || rawValue).trim(),
    uf: (match?.[2] || "").trim(),
  };
};

export const fetchCitiesByUf = async (uf) => {
  const normalizedUf = String(uf || "").trim().toUpperCase();
  if (!normalizedUf) return [];

  if (citiesCache.has(normalizedUf)) {
    return citiesCache.get(normalizedUf);
  }

  const response = await fetch(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${normalizedUf}/municipios?orderBy=nome`
  );

  if (!response.ok) {
    throw new Error("Não foi possível carregar as cidades");
  }

  const data = await response.json();
  const cities = (Array.isArray(data) ? data : [])
    .map((item) => item?.nome)
    .filter(Boolean);

  citiesCache.set(normalizedUf, cities);
  return cities;
};
